/* eslint-disable no-useless-escape */

// RegExpEmailInput
export const VALID_EMAIL_REGEX = /([a-zA-Z0-9_\.\-])+(\+)?([a-zA-Z0-9_\.\-])*\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+\.?/;

// RegExpPostalCodeFormattedUsaOrCanada
export const VALID_ZIP_REGEX = /(?:\d{5}(?:-\d{4})?)|(?:[A-Z]\d[A-Z] \d[A-Z]\d)/;

export const FIRST_WORD_REGEX = /^([\w\-\u0400-\u04FF]+)/g; // \u0400-\u04FF adds support for cyrillic letters

// Remove extra spaces from the text
export const REMOVE_EXTRA_SPACES_REGEX = /\ +/g;

export const JOBCASE_REGEX = /@jobcase.com/i;

export const SHOWDOWN_LISTS_SPACES_REGEX = /^(- .+\n{2,}-)/gim;
